import { WebRoutes } from "consts/enpoints/web";
import { Merchant } from "ui/forms/ECommerce";
import { Step, withApplication } from "ui/organizms/ECommerce/Onboarding/common";
import usePaymentMethods from "./usePaymentMethods";
import { useOnboardingApplication } from "../../hooks";

const PaymentMethods = () => {
    const { getApplicationModel } = useOnboardingApplication();
    const paymentMethods = usePaymentMethods();

    return (
        <Step
            title='Payment Methods'
            getApplicationModel={getApplicationModel}
            route={WebRoutes.Onboarding.Merchant}
        >
            <Merchant.PaymentMethods.Form
                {...paymentMethods}
                sx={{
                    '& > div': {
                        display: 'grid',
                        gap: 1,
                        gridTemplateColumns: {
                            xs: '1fr',
                            md: '1fr 1fr'
                        }
                    }
                }}
            />
        </Step>
    );
};

export default withApplication(PaymentMethods);
